import React, { useState, useEffect } from "react";
import {
  BeadCrumb,
  CustomHeader,
  NotificationModal,
  TextField,
  Button,
  FormError,
  Select,
  Typography,
} from "components";
// import { defaultValidation } from "utils/validators";
import { ROUTES } from "routes/routePaths";
import makeRequest from "services/makeRequest";
import { routes } from "routes/apiRoutes";
import { Formik, Form, ErrorMessage } from "formik";
import { useNavigate, Link } from "react-router-dom";
import { useSelector } from "react-redux";
import { postRequestForTerminal } from "redux/actions/terminalAction";
import { getAgentAccount } from "redux/actions/agentAccountAction";
import * as yup from "yup";
import { RiArrowRightSLine } from "react-icons/ri";
// import { requestTerminalSchema } from "validations/requestTerminalschema";
import { setAlert, getRegionOptions, isSuccessResponse } from "utils/helper";
import { errorHandler } from "services/errorHandler";
import { getRegions } from "redux/actions/regionActions";

const initialValues = {
  requestType: 1,
  pmAccount: "",
  region: "",
  state: "",
  location: "",
};

const RequestTerminal = () => {
  const [showModal, setShowModal] = useState(false);
  const [message, setMessage] = useState("");
  const [stateOptions, setStateOptions] = useState([]);
  const navigate = useNavigate();

  /**
   *
   */
  const { user, agentAccounts, regions } = useSelector((state) => ({
    user: state.user.user,
    agentAccounts: state.agentAccountReducer.agentAccounts,
    regions: state.regions.regions,
  }));

  /**
   *
   */
  useEffect(() => {
    const requestParam = {
      assigned: false,
      agentId: user?.agent_id || null,
      status: "ENABLED",
    };
    getAgentAccount(requestParam);
  }, [user?.agent_id]);

  useEffect(() => {
    getRegions();
  }, []);

  const getSelectedRegionStates = async (regionName) => {
    try {
      const selectedRegion = regions.find(
        (region) => region.name === regionName
      );
      if (selectedRegion) {
        const { data } = await makeRequest(
          "get",
          routes.fetchRegions(`region=${selectedRegion?.id}&type=1`)
        );
        if (isSuccessResponse(data)) {
          setStateOptions(getRegionOptions(data?.data));
        }
      }
    } catch (err) {
      console.log(err);
    }
  };

  const requestTerminalSchema = yup.object().shape({
    pmAccount: yup.string().required("PM account is required"),
    region: yup.string().required("Region is required"),
    state: yup.string().required("State is required"),
    location: yup.string().required("Location is required"),
  });

  /***
   *
   */
  const handleRequest = (values, actions) => {
    const { agentId, requestType, location, pmAccount, region, state } = values;
    const data = {
      agentId: agentId,
      requestType: requestType,
      details: [
        {
          pickupLocation: location,
          pmAccountId: pmAccount,
          // terminalId: ""
          region,
          state,
        },
      ],
    };
    actions.setSubmitting(true);
    postRequestForTerminal(data).then(
      (res) => {
        if ([200, 201].includes(parseInt(res.data.responseCode))) {
          actions.setSubmitting(false);
          actions.resetForm();
          setShowModal(true);
          setMessage(res.data.responseMessage);
        } else {
          actions.setSubmitting(false);
          setAlert(res.data.responseMessage);
        }
      },
      (err) => {
        actions.setSubmitting(false);
        setShowModal(false);
        if (err.response) {
          //handling error
        }
        errorHandler(err);
      }
    );
  };

  /**
   * This is an array of agent account number transform to (value - label) pairs using reduce method
   * @property {array} agentAccounts
   */
  const agentAccountOptions = agentAccounts?.reduce((acc, item) => {
    acc.push({
      value: item.accountId,
      // label:`${item.accountName} - ${item.accountNumber}`
      label: item.accountNumber,
    });
    return acc;
  }, []);

  return (
    <div className="dashboard-containter bg-light pt-2">
      <div className="beadcrumb-margin">
        <BeadCrumb titles={["Terminals", "Request for New Terminal"]} />
      </div>
      <CustomHeader title="Request For New Terminal" titlePosition="center" />
      <div className="full-width-form-container">
        <Link to={ROUTES.viewPmAccounts}>
          <Typography
            variant="caption1"
            state="secondary"
            className={"text-underline text-right"}
          >
            View PM Accounts <RiArrowRightSLine />
          </Typography>
        </Link>
        <Formik
          initialValues={{
            agentId: user?.agent_id || "",
            agentCode: user?.agent_code || "",
            ...initialValues,
          }}
          validationSchema={requestTerminalSchema}
          onSubmit={handleRequest}
        >
          {({
            errors,
            touched,
            getFieldProps,
            setFieldValue,
            isSubmitting,
            values,
          }) => (
            <Form noValidate autoComplete="off">
              <div className="row">
                <div className="col-md-6 mb-3">
                  <TextField
                    name="agentCode"
                    type="text"
                    placeholder="67-GOH"
                    label="Agent's code"
                    disabled
                    {...getFieldProps("agentCode")}
                    hasError={errors.agentCode && touched.agentCode}
                  />
                  <ErrorMessage component={FormError} name="agentCode" />
                </div>

                <div className="col-md-6 mb-3">
                  <Select
                    label="Agent's PM Account"
                    placeholder="Select PM account"
                    name="pmAccount"
                    options={agentAccountOptions}
                    {...getFieldProps("pmAccount")}
                    hasError={errors.pmAccount && touched.pmAccount}
                  />
                  <ErrorMessage component={FormError} name="pmAccount" />
                </div>
                <div className="col-md-6 mb-3">
                  <Select
                    label="Region"
                    placeholder="Select Region"
                    options={getRegionOptions(regions)}
                    loading={!regions.length}
                    name="region"
                    onChange={(e) => {
                      let val = e.target.value;
                      setStateOptions([]);
                      setFieldValue("state", "");
                      setFieldValue("region", val);
                      getSelectedRegionStates(val);
                    }}
                    value={values.region}
                    hasError={errors.region && touched.region}
                  />
                  <ErrorMessage component={FormError} name="region" />
                </div>

                <div className="col-md-6 mb-3">
                  <Select
                    label="State"
                    placeholder="Select state"
                    options={stateOptions}
                    disabled={!values.region}
                    name="state"
                    {...getFieldProps("state")}
                    hasError={errors.state && touched.state}
                  />
                  <ErrorMessage component={FormError} name="state" />
                </div>

                <div>
                  <TextField
                    name="location"
                    type="text"
                    placeholder="Enter Outlet Location"
                    label="Outlet Location"
                    required={false}
                    rows="5"
                    {...getFieldProps("location")}
                    hasError={errors.location && touched.location}
                  />
                  <ErrorMessage component={FormError} name="location" />
                </div>
              </div>

              <div className="mx-auto terminal-cta">
                <Button
                  type="submit"
                  label="Submit Request"
                  fullWidth
                  loading={isSubmitting}
                />
              </div>
              {/* <pre>{JSON.stringify(values,null,2)}</pre> */}
            </Form>
          )}
        </Formik>
      </div>
      {showModal && (
        <NotificationModal
          showModal={showModal}
          onClose={() => {
            setShowModal(false);
            navigate(ROUTES.terminals);
          }}
          // bodyText="Your request has been sent and will be processed. You will be contacted in 3 working days on the outcome of your terminal request!"
          bodyText={message}
          headerText="Request was submitted successfully!"
        />
      )}
    </div>
  );
};

export default RequestTerminal;
